// The browser's copy of SearchWords (app/models/search_words.rb).
// The check-in screen filters its signups here and asks the server for
// members with the same box, so the two must match names the same way. Change
// one, change the other.

const WORD = /[\p{L}\p{N}]+/gu

export function fold(text) {
  return (text || "").normalize("NFC").toLowerCase()
    .replaceAll("æ", "ae").replaceAll("ø", "oe").replaceAll("å", "aa")
    .normalize("NFD").replace(/\p{Mn}/gu, "")
}

export function words(text) {
  return fold(text).match(WORD) || []
}

export function matches(text, query) {
  const folded = fold(text)
  return words(query).every(word => folded.includes(word))
}

export function near(text, query) {
  const own = words(text)
  return words(query).every(word => own.some(ownWord => ownWord.includes(word) || typoOf(word, ownWord)))
}

function typosAllowed(word) {
  if (word.length >= 8) return 2
  if (word.length >= 4) return 1
  return 0
}

function typoOf(typed, word) {
  const allowed = typosAllowed(typed)
  if (allowed === 0) return false

  for (let length = typed.length - allowed; length <= typed.length + allowed; length++) {
    if (distance(typed, word.slice(0, length)) <= allowed) return true
  }
  return false
}

// Optimal string alignment, as in the Ruby: two swapped neighbours are one edit.
function distance(one, other) {
  const table = Array.from({ length: one.length + 1 }, (_, i) => [ i, ...Array(other.length).fill(0) ])
  for (let j = 0; j <= other.length; j++) table[0][j] = j

  for (let i = 1; i <= one.length; i++) {
    for (let j = 1; j <= other.length; j++) {
      const cost = one[i - 1] === other[j - 1] ? 0 : 1
      table[i][j] = Math.min(table[i - 1][j] + 1, table[i][j - 1] + 1, table[i - 1][j - 1] + cost)

      if (i > 1 && j > 1 && one[i - 1] === other[j - 2] && one[i - 2] === other[j - 1]) {
        table[i][j] = Math.min(table[i][j], table[i - 2][j - 2] + 1)
      }
    }
  }

  return table[one.length][other.length]
}
